import { render } from "./DemoNavbar.vue?vue&type=template&id=278a0ee1"
import script from "./DemoNavbar.vue?vue&type=script&lang=js"
export * from "./DemoNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__